import { getExtensionFile } from "./string";
import { VIDEO_FORMATS } from "./constants";

/**
 * @param {Array<Record<string, unknown>>} items
 */
export const buildInitialCreativesFromGalleryItems = (items = []) => {
  return items
    .map((item) => {
      if (!item?.url) {
        return null;
      }

      if (item?.isCarousel && item?.carouselImages?.length > 1) {
        const urls = item.carouselImages
          .map((img) => img?.url || img)
          .filter(Boolean);

        if (urls.length > 0) {
          return { type: "carousel", urls };
        }
      }

      const extension = getExtensionFile(item.url);
      const isVideo = VIDEO_FORMATS.includes(extension);

      return {
        type: isVideo ? "video" : "image",
        url: item.url,
      };
    })
    .filter(Boolean);
};

/**
 * @param {Record<string, unknown>} item
 */
export const buildInitialCreativesFromGalleryItem = (item) => {
  return buildInitialCreativesFromGalleryItems([item]);
};
